export default class SendOfferCommand {
    orderLineIds = []
}